import * as React from "react";
import { Typography, Popover, Card, CardContent, Chip } from "@material-ui/core";
import { Link } from "react-router-dom";

export class HoverModal extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         modalVisible: false,
         anchorEL: null,
         inputValue: ''
      }
   }
   render() {
      const handlePopoverOpen = () => {this.setState({ 'anchorEL': this.state.inputValue })};
      const handlePopoverClose = () => {this.setState({ 'anchorEL': null, inputValue: null })};
      const open = Boolean(this.state.anchorEL);

      return (
         <div className={'hover-modal ' + this.props.className}>
            <Typography
               component={this.props.linkTo?Link:Typography}
               to={this.props.linkTo}
               style={this.props.titleStyle}
               aria-owns={open ? 'mouse-over-popover' : undefined}
               aria-haspopup="true"
               onMouseLeave={handlePopoverClose}
               onMouseEnter={(event) => {
                  this.setState({ inputValue: event.currentTarget })
                  setTimeout(() => handlePopoverOpen(), 500)
               }}
            >
               {this.props.textTitle}
         </Typography>
            <Popover
               container={this.state.anchorEL}
               style={{ pointerEvents: 'none' }}
               id="mouse-over-popover"
               open={open}
               anchorEl={this.state.anchorEL}
               anchorOrigin={this.props.hoverAnchorOrigin}
               transformOrigin={this.props.hoverTransformOrigin}
               onClose={handlePopoverClose}
               disableRestoreFocus
            >
               <Card style={{maxWidth: this.props.maxWidth || 375}}>
                { this.props.cardContent ? (this.props.cardContent) : <CardContent>
                     <div style={{display:'flex', wordWrap:'break-word', marginBottom:'1em'}}>
                        {this.props.avatar && <img style={{marginRight:'10px', borderRadius:50}} src={this.props.avatar} width="50" height="50" />}
                        <div style={{marginRight:'10px'}}>
                        <Typography style={{fontSize:20, fontWeight:400, wordWrap:'break-word'}}>{this.props.hoverTitle}</Typography>
                        {this.props.hoverSubtitle && <Typography style={{fontSize:14, color:'gray', fontWeight:400,wordWrap:'break-word'}}>{this.props.hoverSubtitle}</Typography>}
                        </div>
                        <Chip size="small" color='primary' variant='outlined' label={this.props.chipText}/>
                     </div>
                     {this.props.hoverText && <Typography style={{wordWrap:'break-word'}}>{this.props.hoverText}</Typography>}
                  </CardContent>}
               </Card>
            </Popover>
         </div>

      );

   }
}
